export * from './dossier-fixed-summary.component';
